/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Draftemail_Toast_Schedulecancelled3Inputs */

const en_coinvestments_draftemail_toast_schedulecancelled3 = /** @type {(inputs: Coinvestments_Draftemail_Toast_Schedulecancelled3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schedule cancelled`)
};

/**
* | output |
* | --- |
* | "Schedule cancelled" |
*
* @param {Coinvestments_Draftemail_Toast_Schedulecancelled3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_draftemail_toast_schedulecancelled3 = /** @type {((inputs?: Coinvestments_Draftemail_Toast_Schedulecancelled3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Draftemail_Toast_Schedulecancelled3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_draftemail_toast_schedulecancelled3(inputs)
});
export { coinvestments_draftemail_toast_schedulecancelled3 as "coInvestments_draftEmail_toast_scheduleCancelled" }